import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import ProjectCredit from 'src/app/interfaces/project-credit';
import Organization from '../../interfaces/organization';

type TableSubItem = {
  creditType: string;
  placementStatus: string | null;
  ownership: string | null;
  admittedDate: string | null;
  exitDate: string | null;
};
type TableItem = {
  name: string;
  type: string;
  closingDate: string;
  status: string | undefined;
  details: TableSubItem[];
  outlet: Organization | undefined;
};

@Component({
    selector: 'credit-outlet-table',
    templateUrl: './credit-outlet-table.component.html',
    styleUrls: ['./credit-outlet-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditOutletTableComponent {
  @Input() projectCredits: ProjectCredit[];
  public headerColumns: string[] = ['name', 'type', 'closingDate', 'status'];
  public subHeaderColumns: string[] = [
    'creditType',
    'placementStatus',
    'ownership',
    'admittedDate',
    'exitDate',
  ];
  public tableItems: TableItem[] = [];
  ngOnInit() {
    this.processProjectCredits();
  }
  processProjectCredits() {
    for (let i = 0; i < this.projectCredits.length; i++) {
      let projectCredit = this.projectCredits[i];
      if (projectCredit.projectCreditOutlets) {
        let credit: TableSubItem = {
          creditType: `${projectCredit.taxCreditType?.level} ${projectCredit.taxCreditType?.name} ${projectCredit.taxCreditDesignation?.name}`,
          placementStatus: '',
          ownership: '',
          admittedDate: '',
          exitDate: '',
        };
        for (
          let j = 0;
          j < projectCredit.projectCreditOutlets.length;
          j++
        ) {
          let projectCreditOutlet = projectCredit.projectCreditOutlets[j];
          let name = projectCreditOutlet.fund
            ? projectCreditOutlet.fund.name
            : projectCreditOutlet.certificatedOutlet
            ? projectCreditOutlet.certificatedOutlet.organization.name
            : null;
          if (name) {
            let columnIndex = this.tableItems.findIndex(
              (value: TableItem) => value.name === name
            );
            let column: TableItem;
            if (columnIndex === -1) {
              let type =
                projectCreditOutlet.fund && projectCreditOutlet.fund.fundType
                  ? projectCreditOutlet.fund.fundType.name
                  : '';
              let status = projectCreditOutlet.fund?.fundStatuses?.length
                ? projectCreditOutlet.fund?.fundStatuses[0].status.name
                : '';
              let closingDate = projectCreditOutlet.fund
                ? moment(projectCreditOutlet.fund.close_date).format(
                    'MM/DD/YYYY'
                  )
                : '';
              let details: TableSubItem[] = [];
              column = {
                name,
                type,
                outlet:
                  projectCreditOutlet.fund ??
                  projectCreditOutlet?.certificatedOutlet?.organization,
                closingDate,
                status,
                details,
              };
            } else {
              column = this.tableItems[columnIndex];
            }
            let ownership = `${projectCreditOutlet.ownership}%`;
            let admittedDate =
              projectCreditOutlet.admitted_date &&
              projectCreditOutlet.admitted_date.length > 0
                ? moment(projectCreditOutlet.admitted_date).format('MM/DD/YYYY')
                : null;
            let exitDate =
              projectCreditOutlet.exit_date &&
              projectCreditOutlet.exit_date.length > 0
                ? moment(projectCreditOutlet.exit_date).format('MM/DD/YYYY')
                : null;
            let placementStatus = projectCreditOutlet.fundProjectState?.name;
            let subItem: TableSubItem = Object.assign({}, credit, {
              ownership,
              exitDate,
              admittedDate,
              placementStatus,
            });
            column.details.push(subItem);
            column.details.sort(this.compareCredits);
            if (columnIndex > -1) {
              this.tableItems[columnIndex] = column;
            } else {
              this.tableItems.push(column);
            }
          }
        }
      }
    }
    this.tableItems.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }
  compareCredits(a: TableSubItem, b: TableSubItem): number {
    if (
      a.creditType.indexOf('Federal') > -1 &&
      b.creditType.indexOf('Federal') === -1
    ) {
      return 1;
    } else if (
      a.creditType.indexOf('Federal') === -1 &&
      b.creditType.indexOf('Federal') > -1
    ) {
      return -1;
    }
    return a.creditType.localeCompare(b.creditType);
  }
}
